import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { login } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.png";

const Login = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      const response = await login(credentials);

      localStorage.setItem("user", JSON.stringify(response.user));
      localStorage.setItem("token", response.token);

      navigate(
        response.user.role === "admin"
          ? "/admin/dashboard"
          : "/project_associate/dashboard"
      );
    } catch (error) {
      setErrorMessage("Invalid email or password. Please try again.");
    }
  };

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="card-header">
          <h2>Welcome Back</h2>
          <p className="signup-text">
          Every login is a new beginning✨🚀
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email address"
              value={credentials.email}
              onChange={(e) =>
                setCredentials({ ...credentials, email: e.target.value })
              }
            />
          </div>
          <div className="input-group password-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={credentials.password}
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
            />
            <button
              type="button"
              className="password-toggle"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <Eye /> : <EyeOff />}
            </button>
          </div>
          {errorMessage && <p className="auth-error-message">{errorMessage}</p>}{" "}
          <button type="submit" className="primary-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
